export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--S.7be6a5bf.png";